import { useKeycloak } from '@react-keycloak/web';
import React, { Suspense, useEffect, useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { SDPContext } from 'Contexts';

import { NotFound } from 'Components';
import * as Container from 'Containers';

import useRoutes from './useRoutes';

export default function Routes() {
  const { initialized, keycloak } = useKeycloak();
  const {
    authorizedRoutes,
    unauthorizedRoutes,
    authorizedPaths,
    unauthorizedPaths,
    setCurrentCompany
  } = useRoutes(keycloak.authenticated);

  const {
    state: {
      company: {
        data: { current: currentCompany }
      }
    }
  } = useContext(SDPContext);

  useEffect(() => {
    if (currentCompany?.id) setCurrentCompany(currentCompany);
  }, [currentCompany]);

  return (
    initialized && (
      <Switch>
        <Route path="/" exact>
          <Redirect to="/login" />
        </Route>

        <Route path={unauthorizedPaths} exact>
          <Container.Unauthorized>
            <Switch>
              <Suspense fallback={false}>{unauthorizedRoutes}</Suspense>
            </Switch>
          </Container.Unauthorized>
        </Route>

        {keycloak.authenticated ? (
          <Route path={authorizedPaths} exact>
            <Container.Authorized>
              <Switch>
                <Suspense fallback={false}>{authorizedRoutes}</Suspense>
              </Switch>
            </Container.Authorized>
          </Route>
        ) : (
          <Route path={authorizedPaths} exact>
            <Redirect to="/login" />
          </Route>
        )}

        <Route>
          <NotFound />
        </Route>
      </Switch>
    )
  );
}
